import { render, staticRenderFns } from "./TestTaskDescriptor.vue?vue&type=template&id=3d2dbc28&scoped=true&"
import script from "./TestTaskDescriptor.vue?vue&type=script&lang=ts&"
export * from "./TestTaskDescriptor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2dbc28",
  null
  
)

export default component.exports